// extracted by mini-css-extract-plugin
module.exports =  {"contact-card":"U4zLBFH","contactCard":"U4zLBFH","contact-button":"xz2YfBt","contactButton":"xz2YfBt","avatar-box":"mLzwu79","avatarBox":"mLzwu79"};